<div class="panel-outer">
	<div class="camera-wrapper panel-scene" [ngClass]="{'panel-scene-visible':svcMenuBase.svcMenuCrud.crudMenuFoodMode === 'capturing'}">
		<div class="camera-controls-outer">
			<div class="camera-button camera-button-disable" (click)="disableCaptureMode()">
				<i class="fa-sharp fas fa-arrow-down-right"></i>
			</div>
			<div class="camera-button camera-button-capture" (click)="captureImage()">
			</div>
			<div class="camera-button camera-button-upload">
				<i class="fa-sharp fas fa-upload"></i>
			</div>
			<!--			<div class="camera-button row-span-2" (click)="closeMenuCrudFood()">-->
			<!--				<i class="fa-sharp fal fa-xmark-large"></i>-->
			<!--			</div>-->
		</div>
		<video #videoPlayer autoplay muted playsinline style="display: none;"></video>
		<canvas #canvas></canvas>
		<div class="scan-line"></div>
	</div>
	<div class="panel-scene" [ngClass]="{'panel-scene-visible':svcMenuBase.svcMenuCrud.crudMenuFoodMode === 'processing'}">
		<div class="w-full h-full flex items-center justify-center">
			<span class="loader"></span>

		</div>
	</div>
	<div class="panel-scene" [ngClass]="{'panel-scene-visible':svcMenuBase.svcMenuCrud.crudMenuFoodMode === 'reviewing'}">
		<div class="review-table">
			<div class="review-meal">
				@if (foodRecordNew) {
					<div class="col-wrapper overflow-hidden">
						<div class="text-row meal-type">{{foodRecordNew.ai.analysis.mealType | titlecase}}</div>
						<div class="totals-grid">
							@for (
									key of foodAnalysisTotalsKeys; track key + $index) {
								@let
								dict = foodAnalysisTotalsDict[key];
								<div class="nutrition-row">
									<div class="nutrition-row-item">{{dict.abbr}}</div>
									<div class="nutrition-row-value">{{foodRecordNew.ai.analysis.total[key]}}{{dict.unit}}</div>
								</div>
							}
						</div>
						<div class="accept-button" OnHold (onHold)="svcMenuBase.svcMenuCrud.crudMenuFoodMode = 'awaiting'">Click when Done</div>
						<div class="w-full flex-1 bg-black">

						</div>
					</div>
					<div class="col-wrapper overflow-scroll">
						@for (
								item of foodRecordNew.ai.analysis.items; track item.name) {
							<div class="text-row">
								<div class="text-row-icon">
									<i class="fa-sharp fal" [ngClass]="'fa-'+FoodAnalysisRatingDict[item.processingLevel].icon"></i>
								</div>
								<div class="text-row-inner">{{item.name}}</div>
							</div>
							<div class="text-row">
								<div class="text-row-inner">{{item.portionEstimate}}</div>
							</div>
							<div class="text-row">
								@for (
										tag of item.dietaryTags; track tag) {
									<div>{{tag | titlecase}}</div>
								}
							</div>
							<div class="nutrition-row">
								<div class="nutrition-row-item">{{item.calories}}</div>
								<div class="nutrition-row-value">{{item.calories}}kcal</div>
							</div>
							@for (
									detail of foodAnalysisNutritionDetailKeys; track detail + $index) {
								@let
								dict = foodAnalysisNutritionDetailDict[detail];
								<div class="nutrition-row">
									<div class="nutrition-row-item">{{dict.name}}</div>
									<div class="nutrition-row-value">{{item[detail].grams}}{{dict.unit}}</div>
									<div class="nutrition-row-icon">
										<i class="fa-sharp fal" [ngClass]="'fa-'+FoodAnalysisRatingDict[item[detail].level].icon"></i>
									</div>
								</div>
							}
						}
					</div>
				}
			</div>

		</div>
	</div>
	<div class="panel-scene" [ngClass]="{'panel-scene-visible':svcMenuBase.svcMenuCrud.crudMenuFoodMode === 'awaiting'|| svcMenuBase.svcMenuCrud.crudMenuFoodMode === null}">
		<app-menu-crud-panel-top [rows]="recordRowsLogs">
			<div class="w-full h-full" PanelTop>
				<div class="w-full h-full flex items-center justify-center" (click)="initCaptureMode()">
					<i class="fa-sharp fal fa-camera"></i>
				</div>
			</div>
		</app-menu-crud-panel-top>
	</div>
</div>
